import classes from './CustomAttribution.module.css';
import { useTheme } from '@/assets/styles/themeMantine';
import { useDisclosure } from '@mantine/hooks';
import { Text } from '@mantine/core';
import {
  OverstoryComponent,
  DisclaimerComponent,
  TermsComponent,
  PrivacyComponent,
  DEFAULT_DISCLAIMER_COPY,
  DisclaimerModal,
} from '@/views/map/Footer/Footer';
import { useSmallScreen } from '@/hooks/useWindowDimension';

const MapboxLinks = () => {
  const isSmallScreen = useSmallScreen();
  return (
    <div className={classes.mapboxLinks}>
      <a
        href="https://www.mapbox.com/about/maps/"
        target="_blank"
        rel="noreferrer"
      >
        © Mapbox
      </a>
      <span className={classes.separator}>{isSmallScreen ? ' ' : ' | '}</span>
      <a
        href="http://www.openstreetmap.org/copyright"
        target="_blank"
        rel="noreferrer"
      >
        © OpenStreetMap
      </a>
      <span className={classes.separator}>{isSmallScreen ? ' ' : ' | '}</span>
      <a
        href="https://www.mapbox.com/map-feedback/"
        className={classes.improveMap}
        target="_blank"
        rel="noreferrer"
      >
        <span style={{ fontWeight: 700 }}>Improve this map</span>
      </a>
    </div>
  );
};

interface CustomAttributionProps {
  title?: string;
  compact: boolean /* property for Mapbox Attribution component */;
  useFullVersion: boolean /* use longer content in the disclaimer modal */;
}

export const CustomAttribution = ({
  title,
  compact,
  useFullVersion,
}: CustomAttributionProps) => {
  const theme = useTheme();
  const [opened, { open, close }] = useDisclosure(false);

  const body = !useFullVersion ? (
    DEFAULT_DISCLAIMER_COPY
  ) : (
    <>
      <div className={classes.fullScreen}>
        <h2
          style={{
            ...theme.other.typography.variants.bodyMedium,
          }}
        >
          Overstory information
        </h2>

        {DEFAULT_DISCLAIMER_COPY}
        <TermsComponent useFullVersion={useFullVersion} classes={classes} />
        <PrivacyComponent useFullVersion={useFullVersion} classes={classes} />
      </div>

      <Text style={{ paddingTop: theme.other.spacing.lg }}>
        <div className={classes.fullScreen}>
          <h2
            style={{
              ...theme.other.typography.variants.bodyMedium,
            }}
          >
            Mapbox (background map) information
          </h2>

          <MapboxLinks />
        </div>
      </Text>
    </>
  );

  return (
    <>
      <div className={classes.mapboxAttributionContainer}>
        {!compact ? (
          <>
            <div className={classes.overstoryLinks}>
              <span style={{ fontWeight: 700 }}>| </span>
              <OverstoryComponent classes={classes} />
              <DisclaimerComponent onClickEvent={open} />
              <TermsComponent
                useFullVersion={useFullVersion}
                classes={classes}
              />
              <PrivacyComponent
                useFullVersion={useFullVersion}
                classes={classes}
              />
            </div>

            <MapboxLinks />
          </>
        ) : (
          <span className={classes.mapboxButton} onClick={open}></span>
        )}
        <a
          href="http://mapbox.com/about/maps"
          className={classes.mapboxLogo}
          target="_blank"
          rel="noreferrer"
        >
          Mapbox
        </a>
      </div>

      <DisclaimerModal
        title={title}
        body={body}
        useFullVersion={useFullVersion}
        opened={opened}
        onCloseEvent={close}
      ></DisclaimerModal>
    </>
  );
};
